export const UPDATE_SORT_DIRECTION = "UPDATE_SORT_DIRECTION";
